import { Inject, Injectable, PLATFORM_ID, ɵNOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Actions, Effect } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import * as fromRoot from '../reducer/core.reducer';
import * as coreActions from '../action/core.actions';
import { StateInternalPipe } from './state-internal.pipe';
import { DataService } from '../../service/data';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {APP_SETTINGS } from '../../../modules/ng-express-engine/tokens';
import { StateInteractionService } from '../../service/dynamic/state.interaction.service'; 
import { Subscription } from 'rxjs/Subscription'; 
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { concat } from 'rxjs/observable/concat';
import { UserLoginService } from '../../service/user/user.login.service';
import { StateUserPipe } from './state-user.pipe'
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/first';

@Injectable()
export class StateDataPipe {
    public tagSubscription: Subscription;
    public tagSubscription2: Subscription;
    public rowsSubscription: Subscription;
    public dataSubscription: Subscription;
    private isServer: boolean;
    private _loginPipe: BehaviorSubject<String>;
    private dataPipe: BehaviorSubject<Object>;  
    private dataObject: object;

    constructor(
        @Inject(APP_SETTINGS) private settings: any,
        @Inject(PLATFORM_ID) private platformId: string,
        private store: Store<fromRoot.State>,
        private actions$: Actions,
        private stateInternal: StateInternalPipe,
        private stateInteraction: StateInteractionService,
        private stateUser: StateUserPipe,
        private apiService: DataService,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private loginService : UserLoginService
    ){
      this.isServer = isPlatformServer(this.platformId);
      this._loginPipe = this.loginService.loginState;
    }

    public getApiUrlData(apiUrl: string, dispatch: boolean): Observable<any> {
      apiUrl = this.getPathFromUrl(apiUrl);
      return this.apiService.getData({}, apiUrl, 0, dispatch, true, true);
    }

    public getApiUrlDataEmit(dataSubject:BehaviorSubject<Object>, apiUrl: string, dispatch: boolean){
      apiUrl = this.getPathFromUrl(apiUrl);
      let res;
      this.processDataObservableEmit(dataSubject, apiUrl, {}, this.apiService.getData({}, apiUrl, 0, dispatch, true, false))
      .first()
      .subscribe(res =>{
        dataSubject.next(res);
      })
    }

    public getAddressData( address : string ){
      return this.apiService.getAddressData(address);
    }

    public getDataWithPathElement(element: string, apiUrl: string) {
      apiUrl = this.getPathFromUrl(apiUrl);
      return this.apiService.getDataWithPathElement(element, apiUrl);
    }

    public cleanupDataEntities(){
      if (this.settings['EMPTY_STATE_ON_ROOT']){
          this.stateInteraction.deleteDataEntities();
      }
    }
    private retrieveLazyIndirectData(dataSubject:BehaviorSubject<Object>, path: string){
      const existingData = this.getStaticRouteData(path, {});
      const routeParams = this.activeRoute.snapshot.params;
      let observableResult;
      if (Object.keys(existingData).length > 0){
        observableResult =  Observable.of(existingData);
      }
      else{
        observableResult = this.apiService.getData(routeParams, path, 0, true, true, false);
      }
      this.processDataObservableEmit(dataSubject, path, routeParams, observableResult)
      .first()
      .subscribe(res =>{
        dataSubject.next(res);
      });
    }
    //need to make it configuration based
    public getSeriesDailyEpisodeDataEmit(dataSubject:BehaviorSubject<Object>, meta: any, dateString: string) {
        if (!meta.internal_route){
          dataSubject.next(null);
          return;
        }
        const path = meta.internal_route + "/episode-data/" + dateString;
        this.retrieveLazyIndirectData(dataSubject, path);
    }

    public loadMetaInternalRoute(dataSubject:BehaviorSubject<Object>, meta: any){
      if (!meta.internal_route){
        dataSubject.next(null);
        return;
      }
      const path = meta.internal_route;
      this.retrieveLazyIndirectData(dataSubject, path);
    }

    public getFreshData(url){
      url = this.getPathFromUrl(url);
      return this.apiService.getFreshData(url);
    }

    public deleteStaleSearchItems(term){
      this.stateInteraction.deleteStaleSearchItems(term);
    }

    public setInternalUrlListRootState(route){
      const prevRoot = this.stateInternal.getInternalStateValue('rootDetail');
      const prevList = this.stateInternal.getInternalStateValue('urlLists');
      if (prevRoot) {
        this.store.dispatch( new coreActions.RemoveDataEntityList({ keys: prevList }));
      }
  
      this.stateInternal.setInternalStateValue('rootDetail', route);
      this.stateInternal.setInternalStateValue('urlLists', [route]);
    }
    
    public deleteAllSearchItems(){
      this.stateInteraction.deleteAllSearchItems();
    }

    public removeSeriesKey(key: string){
      this.store.dispatch(new coreActions.RemoveSeriesKey({ key: key }));
    }

    public getStaticRouteData(url?, params?) {
      if (!url){
        url = this.router.url;
        params = this.activeRoute.snapshot.params;
      }
      url = this.getPathFromUrl(url);
      return Object.assign({}, this.stateInteraction.getStaticRouteData(url, params));
    }

    private getPathFromUrl(url) {
      return url.split("?")[0];
    }
    
    public getStaticRouteDataByUrl(url) {
      url = this.getPathFromUrl(url);
      return Object.assign({}, this.stateInteraction.getStateData(url.replace(this.settings['DATA_API_ENDPOINT'],'')));
    }    

    public  dispatchNextSinglePage(url: string){
        if (!url){
          return;
        }
        url = url.trim();
        url = this.getPathFromUrl(url);
        if (this.tagSubscription2){
          this.tagSubscription2.unsubscribe();
        }
        this.tagSubscription2 = this.apiService.getData({}, url, 0, true, true, false).subscribe();
    }

    public dispatchNextPage(rows: Array<Object>){
        let bucket = [];
        for (let row of rows){
          if (row['meta'] && row['meta']['next_page_url']){
              let url = row['meta']['next_page_url'].trim();
              url = this.getPathFromUrl(url);
              if (url && url.length > 10){
                bucket.push(this.apiService.getData({}, url, 0, true, true, false))
              }
          }
        }
        if (bucket.length > 0){
          this.tagSubscription = Observable.forkJoin(bucket).subscribe(); //leak handled
        }
    }

    public dispatchDataToStore(content: Object, url){
      url = this.getPathFromUrl(url);
      this.store.dispatch(new coreActions.LoadDataItemSuccessAction({ dataContent: content, isSlug: true, apiUrl: url }));
    }

    public getStoreData(routeParams: Object, url: string, maxCount?: number) {
      url = (url) ? url : this.router.url;
      url = (url == "/") ? this.settings['HOME_ROUTE'] : url;
      url = this.getPathFromUrl(url);
      let source =  Object.assign({}, this.stateInteraction.getStaticRouteData(url, routeParams));
      let dataList;
      let total_count = 0;
      if (source['data'] && Array.isArray(source['data'])){
        dataList = source['data'] as Array<Object>;
        total_count = source['data'].length;
        if (maxCount){
          dataList = dataList.slice(0, maxCount);
          source['data'] = dataList;
        }
      }
      source['total_count'] = total_count;
      return source;
    }

    public getPollDataAsObservableEmit( dataSubject:BehaviorSubject<Object>, routeParams: Object){
      let url = this.router.url;
      url = this.getPathFromUrl(url);
      dataSubject.next(this.processDataObservableEmit(dataSubject, url, routeParams, this.apiService.getData(routeParams, url, 0, true, true, false)));
    }

    public getRouteDataAsObservableEmit(dataSubject:BehaviorSubject<Object>, routeParams: Object, url: string = null, asyncChildren? : boolean){
      let result;
      url = (url) ? url : this.router.url;
      url = (url == "/") ? this.settings['HOME_ROUTE'] : url;
      url = (url.indexOf('/switch') > -1) ? url.replace('/switch','') : url;
      url = this.getPathFromUrl(url);
      // if (url.indexOf('playlists/') > -1){
      //   if (url.indexOf('videos/') > -1){
      //     url = url.slice(0, url.indexOf('/videos'));
      //     delete routeParams['videoSlug'];
      //   }
      // }
      asyncChildren = (asyncChildren) ? asyncChildren : false;
      let data = this.stateInteraction.getStaticRouteData(url, routeParams);
      if (url.indexOf('contact') > -1){
        return Observable.of(true);
      }
      if (data == null) {
        //data coming from the server
        this.processDataObservableEmit(dataSubject, url, routeParams, this.apiService.getData(routeParams, url, 0, true, true, false))
        .first()
        .subscribe(res =>{
          dataSubject.next(res);
        })
        
      }
      else {
        //console.log("wwaikiki");
        //console.log(data);
        //console.log("wwaikiku");
        this.store.dispatch(new coreActions.LoadExistingAction({ route: url, apiUrl: url }));
        
        if (data["error"] != null){
          //console.log("error found 2");
          dataSubject.next(null);
        }
        else{
          dataSubject.next(this.handleInternalState(dataSubject, data, routeParams, url, true, false, data['meta'], null));
          //result = this.stateInternal.handleInternalState(data, routeParams, url, true, false, null);
        }
        //return Observable.of(result);
      } 
    }

    public getRouteDataAsObservable(routeParams: Object, url: string = null, asyncChildren? : boolean): Observable<any> {
      let result;
      url = (url) ? url : this.router.url;
      url = (url == "/") ? this.settings['HOME_ROUTE'] : url;
      url = (url.indexOf('/switch') > -1) ? url.replace('/switch','') : url;
      url = this.getPathFromUrl(url);
      // if (url.indexOf('playlists/') > -1){
      //   if (url.indexOf('videos/') > -1){
      //     url = url.slice(0, url.indexOf('/videos'));
      //     delete routeParams['videoSlug'];
      //   }
      // }
      asyncChildren = (asyncChildren) ? asyncChildren : false;
      let data = this.stateInteraction.getStaticRouteData(url, routeParams);
      if (url.indexOf('contact') > -1){
        return Observable.of(true);
      }
      if (data == null) {
        //data coming from the server
        return this.processDataObservable(url, routeParams, this.apiService.getData(routeParams, url, 0, true, true, false));
      }
      else {
        //console.log("wwaikiki");
        //console.log(data);
        //console.log("wwaikiku");
        this.store.dispatch(new coreActions.LoadExistingAction({ route: url, apiUrl: url }));
        
        if (data["error"] != null){
          //console.log("error found 2");
          result = data;
        }
        else{
          result = this.stateInternal.handleInternalState(data, routeParams, url, true, false, null);
        }
        return Observable.of(result);
      }
    }

    private isEmpty(obj: Object){
      if (!obj) return true;
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    }

    private processDataEmit(dataSubject:BehaviorSubject<Object>, url: string, routeParams: any, data: Object): Object{
      let result;
      routeParams = (this.isEmpty(routeParams)) ? this.activeRoute.snapshot.params : routeParams;
      //error so we do nothing
      if (data["error"] != null){
        result = null;
      }
      else{
        //delete invalid rows
        try{
          if (data['rows'] != null && data['rows'].length > 0){
            const validRows = ([].concat(data['rows'])).filter(row => row['error'] == null);
            data['rows'] = [].concat(validRows);
          }
        }
        catch(e){}
        if (url.indexOf('tags/') > -1){
          if (data['rows'] && Array.isArray(data['rows'])){
            this.dispatchNextPage(data['rows']);
          }
        }
        //process internal state
        result = this.handleInternalState(dataSubject, data, routeParams, url, true, false, data['meta'], null);
      }
      if (result && result['asyncBucket'] && result['asyncBucket'].length > 0){
          if (this.rowsSubscription){
            this.rowsSubscription.unsubscribe();
          }
          this.rowsSubscription = Observable.forkJoin(result['asyncBucket']).subscribe(); //leak handled
      }
      this.addUrlIfNeeded(url);
      return result;
    }

    private processData(url: string, routeParams: any, data: Object): Object{
      let result;
      //error so we do nothing
      if (data["error"] != null){
        result = data;
      }
      else{
        //delete invalid rows
        try{
          if (data['rows'] != null && data['rows'].length > 0){
            const validRows = ([].concat(data['rows'])).filter(row => row['error'] == null);
            data['rows'] = [].concat(validRows);
          }
        }
        catch(e){}
        if (url.indexOf('tags/') > -1){
          if (data['rows'] && Array.isArray(data['rows'])){
            this.dispatchNextPage(data['rows']);
          }
        }
        //process internal state
        result = this.stateInternal.handleInternalState(data, routeParams, url, true, false, null);
      }
      if (result && result['asyncBucket'] && result['asyncBucket'].length > 0){
          if (this.rowsSubscription){
            this.rowsSubscription.unsubscribe();
          }
          this.rowsSubscription = Observable.forkJoin(result['asyncBucket']).subscribe(); //leak handled
      }
      this.addUrlIfNeeded(url);
      return result;
    }

    private addUrlIfNeeded(url){
      if (!this.isServer){
        const currentUrlList = this.stateInternal.getInternalStateValue('urlLists');

        if(currentUrlList && currentUrlList.indexOf(url) < 0){
          currentUrlList.push(url);
        }
        this.stateInternal.setInternalStateValue('urlLists', currentUrlList);      
      }
    }

    private processDataObservable(url: string, routeParams: any, dataObservable: Observable<any>){
      return dataObservable
        .map(data => this.processData(url, routeParams, data));
    } 

    private processDataObservableEmit(dataSubject:BehaviorSubject<Object>, url: string, routeParams: any, dataObservable: Observable<any>){
      return dataObservable
        .map(data => this.processDataEmit(dataSubject, url, routeParams, data));
    } 

    private createMockObjectArray(item){
      const bucket = new Array(item.meta['total_count']);
      let returnItem:any = {};
      returnItem.meta = item.meta;
      returnItem.meta.loading = true;
  
      const mock = {
        meta: {
          obj_type: 'mock',
          render_style: 'mock'
        }
      } 
      bucket.fill(mock);
      returnItem.data = bucket;
  
      return returnItem;
    }


    public getAsyncChildDataAsObservable(dataSubject:BehaviorSubject<Object>, item: object, routeParams: any, notify: boolean, maxCount?: number){
      //console.log(item); 
      if (item == null){
        dataSubject.next(null);
        return; //Observable.of(null);
      }
      let url  = (this.router.url == "/") ? this.settings['HOME_ROUTE'] : this.router.url;
      const getUrl = item['get_url'];
      let apiUrl = getUrl;
  
      if (apiUrl == null){
        apiUrl = item['meta'] == null ? null : item['meta']['details_url'];
      }
      if (apiUrl){
        apiUrl = this.getPathFromUrl(apiUrl);
      }
      //url = apiUrl;
      if (!apiUrl){
        if ((item['data'] && item['data'].length > 0) || (item['meta'])){
          url = url.replace(this.settings['DATA_API_ENDPOINT'], "");
          this.addUrlIfNeeded(url);
          dataSubject.next(this.handleInternalState(dataSubject, item, routeParams, url, false, notify, item['meta'], maxCount));
          //return Observable.of(this.stateInternal.handleInternalState(item, routeParams, url, false, notify, item['meta'], maxCount));
        }
        else{
          dataSubject.next(null);
          return;
          //return Observable.of(null);
        }
      }
      else{
        apiUrl = apiUrl.replace(this.settings['DATA_API_ENDPOINT'], "");
        this.addUrlIfNeeded(apiUrl);
        const data = this.stateInteraction.getStateData(apiUrl);
        if (item['data'] && item['data'].length > 0){
          if (data && data['data'] && data['data'].length > 0 && item['data'].length != data['data'].length){
            item['data'] = data['data'];
          }
          if(!data && !this.isServer){
            this.store.dispatch(new coreActions.LoadDataItemSuccessAction({ dataContent: item, isSlug: true, apiUrl: apiUrl }));
          }
          dataSubject.next(this.handleInternalState(dataSubject, item, routeParams, url, false, notify, item['meta'], maxCount));
        
        }
        else{
          if (!getUrl && (item['meta'])){
            dataSubject.next(this.handleInternalState(dataSubject, item, routeParams, url, false, notify, item['meta'], maxCount));
          }
          else{
            if (this.isServer) {
              if (this.settings['USE_MOCK_PATTERN']){
                dataSubject.next(this.createMockObjectArray(item));
                //return Observable.of(this.createMockObjectArray(item));
              }
              else{
                dataSubject.next(null);
                //return Observable.of(null);
              }
            }
            else {
              if(!data){
                if (this.settings['USE_MOCK_PATTERN']){
                  //console.log('returning concated obs, mock first');
                  dataSubject.next(this.createMockObjectArray(item));
                  
                  const self = this;
                  this.apiService.getData({}, apiUrl, 0, true, true, false)
                    .map(res => { 
                      return this.stateInternal.handleInternalState(res, routeParams, url, false, notify, item['meta'], maxCount) })
                    .first()
                    .subscribe(finalRes => {
                      dataSubject.next(finalRes);
                      this.listenToUserStats(dataSubject, finalRes, routeParams, url, false, notify, item['meta'], maxCount);
                    });
                }
                else{
                  this.apiService.getData({}, apiUrl, 0, true, true, false)
                    .map(res => { return this.stateInternal.handleInternalState(res, routeParams, url, false, notify, item['meta'], maxCount) })
                    .first()
                    .subscribe(finalRes => {
                      dataSubject.next(finalRes);
                      this.listenToUserStats(dataSubject, finalRes, routeParams, url, false, notify, item['meta'], maxCount);
                    });                  
                }
              
              }
              else{
                dataSubject.next(this.handleInternalState(dataSubject, data, routeParams, url, false, notify, item['meta'], maxCount));
              }
            }
          }
        }
      }
    }

    private listenToUserStats(dataSubject:BehaviorSubject<Object>, data: Object, routeParams: Object, url: string, isContainer: boolean, notify: boolean, meta: Object, maxCount: number){
//       console.log("aameta");
//       console.log(data);
      if (!this.isServer && this.settings['LOGIN_LISTENER_ENABLED'] && !this._loginPipe.closed){
        this._loginPipe
        .subscribe(finalRes => {
          if( finalRes == "stats_retrieved"){
            const newVal = this.stateInternal.handleInternalState(data, routeParams, url, false, notify, meta, maxCount);
            if (JSON.stringify(data) != JSON.stringify(newVal)){
              if (dataSubject && dataSubject.observers && dataSubject.observers.length > 0){
                dataSubject.next(newVal);
              }
            }
          }  
        });
      }
    }

    private handleInternalState(dataSubject:BehaviorSubject<Object>, data: Object, routeParams: Object, url: string, isContainer: boolean, notify: boolean, meta: Object, maxCount: number){
        const processed = this.stateInternal.handleInternalState (data, routeParams, url, isContainer, notify, meta, maxCount);
        this.listenToUserStats(dataSubject, data, routeParams, url, false, notify, meta, maxCount)
        return processed;
    }

    public nextAsyncChildDataAsObservable(data: Array<object>, routeParams: any, notify: boolean, maxCount?: number){
      const routeData = this.getStaticRouteData();
      const lastMetaSlug = (data && (data.length > 0)) ? data[data.length -1]['meta_slug'] : null;
      const routeDataRows = routeData['rows'];
      let nextRow, nextRowIndex;
      
      if (lastMetaSlug){
        for(var k = 0; k < routeDataRows.length; k++){
          const routeDataRow = routeDataRows[k];
          if (routeDataRow['meta']['slug'] == lastMetaSlug && (k < routeDataRows.length - 1)){
            nextRowIndex = k + 1;
            break;
          }
        }
      }
      
      if (nextRowIndex){
        nextRow = routeDataRows[nextRowIndex];
        const url  = (this.router.url == "/") ? this.settings['HOME_ROUTE'] : this.router.url;
        const getUrl = nextRow['get_url'];
        let apiUrl = getUrl;
        if (apiUrl == null){
          apiUrl = nextRow['meta'] == null ? null : nextRow['meta']['details_url'];
        }
        //let itemData = item['data'];
        return this.apiService.getData({}, apiUrl, 0, true, true, false)
          .map(res => { return this.stateInternal.handleInternalStateAndMerge(res, routeParams, url, false, notify, data) });
      }
    } 

    public getMergedMetaRows(rows : Array<Object>){
      let res = [];
      const routeData = this.getStaticRouteData();
      const routeDataRows = routeData['rows'];
      for(let routeDataRow of routeDataRows){
        res.push(routeDataRow['meta']);
      }
      return res;
    }

    public getFlattenedRowDataAsObservable( component : any, data: any, routeParams: any ) : Observable<any>{
      const rows = component.filterRows;
      const url  = (this.router.url == "/") ? this.settings['HOME_ROUTE'] : this.router.url;
      const routeData = this.getStaticRouteData();
      const routeDataRows = routeData['rows'];
      let bucket: Array<any> = [];
      if( data.meta && data.meta.slug ){
        bucket = bucket.concat( this.analyzeRowData( routeDataRows, data ));
      }else{
        // apply next async logic
      }
      return Observable
        .forkJoin( bucket )
        .map(res => {
          let holder : Array<any> = [];
          res.forEach((resItem, index, arr) =>{
            this.stateInternal.handleInternalState(resItem, routeParams, url, false, false, null); 
            component.filterRows.forEach((obj,index, arr) =>{
                if( resItem['meta']['slug'] == obj['meta']['slug'] && resItem['data'].length > 0 && obj.data.length == 0){
                  obj.data = resItem['data'];
                }
            });
          });
          return this.mergeFlattenedRowData(component.filterRows);
        });
    }

    private analyzeRowData( rows : any, item : any ) : Array<any>{
      const arr : Array<any>    = [];
      const slug : string       = item.meta.slug;
      const rowItem : any       = rows.find(row => {return row.meta.slug == item.meta.slug;});
      const index : number      = rows.indexOf( rowItem );
      const prevIndex : number  = index-1;
      const nextIndex : number  = index+1;
      
      if( rows[prevIndex] &&  rows[prevIndex].get_url && rows[prevIndex].data.length == 0){
        arr.push(this.apiService.getData({}, rows[prevIndex].get_url, 0, true, true, false));
      }else if(rows[prevIndex] &&  rows[prevIndex].data.length > 0 ){
        arr.push(Observable.of( rows[prevIndex]));
      }
      if( rows[index] && rows[index].get_url && rows[index].data.length == 0){
        arr.push(this.apiService.getData({}, rows[index].get_url, 0, true, true, false));
      }else if(rows[index] &&  rows[index].data.length > 0 ){
        arr.push(Observable.of( rows[index]));
      }
      if( rows[nextIndex] && rows[nextIndex].get_url && rows[nextIndex].data.length == 0){
        arr.push(this.apiService.getData({}, rows[nextIndex].get_url, 0, true, true, false));
      }else if(rows[nextIndex] &&  rows[nextIndex].data.length > 0 ){
        arr.push(Observable.of( rows[nextIndex]));
      }
  
      return arr;
    }
  
    private mergeFlattenedRowData( item : Array<any>) : any{
      let holder : Array<any> = [];
      item.forEach( obj => {
          holder = holder.concat( obj.data );
      });
      
      return holder;
    }

      
}




// WEBPACK FOOTER //
// ./src/angular-engine/engine/state/effect/state-data.pipe.ts